import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useApplianceLookupResults = () =>
  useSelector(store, (state) => state.context.applianceLookupResults);
